/**
 * Custom FontAwesome icon constants for use across the application.
 * These icons are registered in CustomIconService during app initialization.
 *
 * @example
 * // In TypeScript component:
 * import { CustomIcons } from '@common/constants';
 *
 * export class MyComponent {
 *   fullContainerIcon = CustomIcons.FULL_CONTAINER;
 *   emptyContainerIcon = CustomIcons.EMPTY_CONTAINER;
 * }
 *
 * @example
 * // In HTML template:
 * <fa-icon [icon]="fullContainerIcon"></fa-icon>
 *
 * @example
 * // Direct usage with getter:
 * get containerIcon() {
 *   return CustomIcons.FULL_CONTAINER;
 * }
 */

export class CustomIcons {
    /** Full container icon - represents a full shipping container */
    static readonly FULL_CONTAINER: any = ['custom', 'full-container'];

    /** Empty container icon - represents an empty shipping container */
    static readonly EMPTY_CONTAINER: any = ['custom', 'empty-container'];

    /** Container yard icon - represents a container yard or storage area */
    static readonly CONTAINER_YARD: any = ['custom', 'container-yard'];
}
